import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const CONTACTMANAGER_REQUEST = 'CONTACTMANAGER_REQUEST';
export const CONTACTMANAGER_SUCCESS = 'CONTACTMANAGER_SUCCESS';
export const CONTACTMANAGER_FAILURE = 'CONTACTMANAGER_FAILURE';

export const FACILITIES_REQUEST = 'FACILITIES_REQUEST';
export const FACILITIES_SUCCESS = 'FACILITIES_SUCCESS';
export const FACILITIES_FAILURE = 'FACILITIES_FAILURE';

export const CONTACT_DETAILS_REQUEST = 'CONTACT_DETAILS_REQUEST';
export const CONTACT_DETAILS_SUCCESS = 'CONTACT_DETAILS_SUCCESS';
export const CONTACT_DETAILS_FAILURE = 'CONTACT_DETAILS_FAILURE';

export const CONTACT_UPDATE_REQUEST = 'CONTACT_UPDATE_REQUEST';
export const CONTACT_UPDATE_SUCCESS = 'CONTACT_UPDATE_SUCCESS';
export const CONTACT_UPDATE_FAILURE = 'CONTACT_UPDATE_FAILURE';

export const CONTACT_TYPES_REQUEST = 'CONTACT_TYPES_REQUEST';
export const CONTACT_TYPES_SUCCESS = 'CONTACT_TYPES_SUCCESS';
export const CONTACT_TYPES_FAILURE = 'CONTACT_TYPES_FAILURE';

export const CLIENT_CONTACTS_REQUEST = 'CLIENT_CONTACTS_REQUEST';
export const CLIENT_CONTACTS_SUCCESS = 'CLIENT_CONTACTS_SUCCESS';
export const CLIENT_CONTACTS_FAILURE = 'CLIENT_CONTACTS_FAILURE';

export const LOCATION_CONTACTS_REQUEST = 'LOCATION_CONTACTS_REQUEST';
export const LOCATION_CONTACTS_SUCCESS = 'LOCATION_CONTACTS_SUCCESS';
export const LOCATION_CONTACTS_FAILURE = 'LOCATION_CONTACTS_FAILURE';

export const PATIENT_CONTACTS_REQUEST = 'PATIENT_CONTACTS_REQUEST';
export const PATIENT_CONTACTS_SUCCESS = 'PATIENT_CONTACTS_SUCCESS';
export const PATIENT_CONTACTS_FAILURE = 'PATIENT_CONTACTS_FAILURE';

export const REFERRAL_CONTACTS_REQUEST = 'REFERRAL_CONTACTS_REQUEST';
export const REFERRAL_CONTACTS_SUCCESS = 'REFERRAL_CONTACTS_SUCCESS';
export const REFERRAL_CONTACTS_FAILURE = 'REFERRAL_CONTACTS_FAILURE';

export const DOCUMENT_TYPES_REQUEST = 'DOCUMENT_TYPES_REQUEST';
export const DOCUMENT_TYPES_SUCCESS = 'DOCUMENT_TYPES_SUCCESS';
export const DOCUMENT_TYPES_FAILURE = 'DOCUMENT_TYPES_FAILURE';


export function requestContacts(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/contact/search?${query}`,
      method: 'GET',
      types: ['CONTACTMANAGER_REQUEST', 'CONTACTMANAGER_SUCCESS', 'CONTACTMANAGER_FAILURE']
    }
  };
}

export function requestContactDetails(contactId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/contact/${contactId}?${query}`,
      method: 'GET',
      types: [
        { type: 'CONTACT_DETAILS_REQUEST', meta: { contactId } },
        { type: 'CONTACT_DETAILS_SUCCESS', meta: { contactId } },
        { type: 'CONTACT_DETAILS_FAILURE', meta: { contactId } },
      ]
    }
  }
}

export function updateContactDetails(contact, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/contact?${query}`,
      method: 'POST',
      body: JSON.stringify(contact),
      types: ["CONTACT_UPDATE_REQUEST", "CONTACT_UPDATE_SUCCESS", "CONTACT_UPDATE_FAILURE"]
    }
  }
}

export function requestFacilityContacts(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/contact/facility?${query}`,
      method: 'GET',
      types: ["FACILITIES_REQUEST", "FACILITIES_SUCCESS", "FACILITIES_FAILURE"]
    },
  };
}

export function deleteFacilityContact(contactId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/contact/facility/delete/${contactId}?${query}`,
      method: 'PUT',
      body: JSON.stringify(contactId),
      types: ["FACILITYCONTACT_DELETE_REQUEST", "FACILITYCONTACT_DELETE_SUCCESS", "FACILITYCONTACT_DELETE_FAILURE"]
    }
  }
}

export function requestContactTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/contact-types/all?${query}`,
      method: 'GET',
      types: ['CONTACT_TYPES_REQUEST', 'CONTACT_TYPES_SUCCESS', 'CONTACT_TYPES_FAILURE',]
    }
  }
}

export function requestClientContacts(employerCodeNumber, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/client-contacts/${employerCodeNumber}?${query}`,
      method: 'GET',
      types: ["CLIENT_CONTACTS_REQUEST", "CLIENT_CONTACTS_SUCCESS", "CLIENT_CONTACTS_FAILURE"]
    },
  };
}

export function requestLocationContacts(locationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/location-contacts/${locationId}?${query}`,
      method: 'GET',
      types: ["LOCATION_CONTACTS_REQUEST", "LOCATION_CONTACTS_SUCCESS", "LOCATION_CONTACTS_FAILURE"]
    },
  };
}

export function requestPatientContacts(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient-contacts/${patientId}?${query}`,
      method: 'GET',
      types: ["PATIENT_CONTACTS_REQUEST", "PATIENT_CONTACTS_SUCCESS", "PATIENT_CONTACTS_FAILURE"]
    },
  };
}

export function requestReferralContacts(referralId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/referral-contacts/${referralId}?${query}`,
      method: 'GET',
      types: ["REFERRAL_CONTACTS_REQUEST", "REFERRAL_CONTACTS_SUCCESS", "REFERRAL_CONTACTS_FAILURE"]
    },
  };
}

export function requestDocumentTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/document-types/all?${query}`,
      method: 'GET',
      types: ['DOCUMENT_TYPES_REQUEST', 'DOCUMENT_TYPES_SUCCESS', 'DOCUMENT_TYPES_FAILURE',]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contact-manager/ContactManagerActions.js